import { useTranslation } from 'react-i18next';
import { useMonkAppState } from '@monkvision/common';
import { DamageDisclosure } from '@monkvision/inspection-capture-web';
import { useNavigate } from 'react-router-dom';
import { AddDamage, CaptureWorkflow, VehicleType } from '@monkvision/types';
import styles from './DamageDisclosurePage.module.css';
import { Page } from '../pages';
import { useUpdateTeslaAdditionalData } from '../../hooks';

export function DamageDisclosurePage() {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const { config, authToken, inspectionId, vehicleType } = useMonkAppState({
    requireInspection: true,
    requireWorkflow: CaptureWorkflow.PHOTO,
  });
  const { handlePictureTaken } = useUpdateTeslaAdditionalData();

  return (
    <div className={styles['container']}>
      <DamageDisclosure
        {...config}
        apiConfig={{
          authToken,
          apiDomain: config.apiDomain,
          thumbnailDomain: config.thumbnailDomain,
        }}
        inspectionId={inspectionId}
        onComplete={() => navigate(Page.PHOTO_CAPTURE)}
        onPictureTaken={handlePictureTaken}
        lang={i18n.language}
        vehicleType={vehicleType ?? VehicleType.SEDAN}
        addDamage={AddDamage.PART_SELECT}
      />
    </div>
  );
}
